export const localeSlug = {
  slugPart1: {de: 'stationen', en: 'locations'},
  slugPart2: {de: 'autovermietung', en: 'car-rental'},
  title: {de: 'Autovermietung', en: 'Car Rental'},
  stations: {de: 'Stationen', en: 'Stations'},
  rates: {de: 'tarife', en: 'rates'},
  group: {de: 'gruppe', en: 'group'},
};

export const getLocaleSlug = (
  objectKey: 'title' | 'slugPart1' | 'slugPart2' | 'stations' | 'rates' | 'group',
  locale: 'de' | 'en' | string,
  fallbackLocale: string = 'de',
) => {
  return localeSlug[objectKey]?.[locale] || localeSlug[objectKey]?.[fallbackLocale];
};
